const styles = {
  grid: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

export default styles;
